import _ from 'lodash';
import React from 'react';
import config from '../../../../constants/config';
import { CompanyT, VariablesObj } from '../../../../types/Company';
import { JobT, RevenueLineItemT } from '../../../../types/Job'
import { TransactionT } from '../../../../types/TransactionT'
import { copyObject } from '../../../../utils';
import { AxiosInstance } from '../../../../utils/RequestMethods'
import { JobMode } from '../Job';
import { LineItemPayment } from './LineItemPayment';
import { Box, Button } from '@mui/material'

import PayJob from './PayJob';
import { getRevenueFromTrasactions, revenueExistInTransactions } from '../JobUtils';
import { PaymentsReceipt } from './PaymentsReceipt';



interface RevenueLineItemDetailsT extends RevenueLineItemT {
    transaction: TransactionT
}


export type IPaymentsTabProps = {
    company: CompanyT
    job: JobT
    jobMode: JobMode
    updateJob(key: string, value: any): void
    refreshJob(newJob: JobT): void
    saveJob(): Promise<JobT>
    reloadJob(): Promise<JobT>
    tabIsActive: boolean
}

const PaymentsTab: React.FC<IPaymentsTabProps> = (props) => {
    const [revenue, setRevenue] = React.useState(null);
    const [itemsInTrasactions, setItemsInTrasactions] = React.useState<Array<RevenueLineItemDetailsT>>([]);
    const [isReady, setIsReady] = React.useState(false);
    const [refreshing, setRefreshing] = React.useState(false);
    const [revenueItems, setRevenueItems] = React.useState([]);
    const [transactions, setTransactions] = React.useState<Array<TransactionT>>([]);
    const [companyVariables, setCompanyVariables] = React.useState(VariablesObj)



    React.useEffect(() => {

        getTransactions()
    }, []);
    React.useEffect(() => {
        // console.log("financial->cogs",financial.cogs)
        if (!_.isEqual(props.job.financial.revenue, revenue)) {
            const revenueClone = props.job.financial.revenue
            const revenueItemsClone: Array<RevenueLineItemT> = revenueClone && revenueClone.lineItems ? copyObject(revenueClone.lineItems) : []
            setRevenueItems(revenueItemsClone)
            // setRevenue(props.job.financial.revenue)

        }
    }, [props.job.financial.revenue]);


    // Effected when company is updated
    React.useEffect((): void => {
        if (props.job.companyInfo && props.job.companyInfo.variables) {
            setCompanyVariables({ ...VariablesObj, ...props.job.companyInfo.variables })
        }
    }, [props.job.companyInfo])



    React.useEffect(() => {
        // console.log("financial->cogs",financial.cogs)

        setRefreshing(true)
        setItemsInTrasactions(getRevenueFromTrasactions(revenueItems, transactions))
        setRefreshing(false)
    }, [transactions, isReady]);


    const getTransactions = async (): Promise<void> => {
        // setTransactions([])
        let params = {
            // userId: props.job.client.id,
            productId: props.job.id,
            status: "complete",
            all: true,
        }

        let options = {
            data: params
        }

        AxiosInstance.get(`${config.url.jobs}/${props.job.id}/transactions`, options).then((res) => {
            if (res && res.data) {
                console.log("transactions", res.data)
                setTransactions(res.data)
            } else {
                setTransactions([])
            }

            setTimeout(() => {
                setIsReady(true)
            }, 100);

        }).catch((error) => {
            setTransactions([])
            setIsReady(true)
        })
    }


    const getItemsByPay = React.useCallback((paid = false) => {
        let items = []
        revenueItems.map((item, index) => {
            // let findTransaction = transactions.find((x) => x.paymentId == item.id)
            if (!item.paid && !revenueExistInTransactions(item, transactions)) {
                items.push(item)
            } else {
                if (paid) {
                    items.push(item)
                }
            }

        })
        return items
    }, [revenueItems, transactions]);



    const lineItems = getItemsByPay()
    const lineItemsPaid = getItemsByPay(true)


    if (!props.tabIsActive) {
        return null
    }
    return (
        <Box mt={2} ml={1} mr={1} >



            {/*
                use for loading
                Skeleton
            */}
            {!isReady && [1, 2].map((item, index) => {
                return (
                    <LineItemPayment
                        key={index}
                        job={props.job}
                        isPaid={true}
                        item={null}
                        index={index}
                        isLoading={true}
                        companyVariables={companyVariables} />
                )
            })}


            {(isReady && props.jobMode == "edit" && props.job.jobStatus != "inquiring" && lineItems.length <= 0) && <PaymentsReceipt
                job={props.job}
                companyVariables=
                {companyVariables}
                transactions={transactions}
                items={lineItemsPaid} />}

            {(isReady && props.jobMode == "edit" && lineItems.length > 0) && <PayJob
                titleButton={props.job.jobStatus == "inquiring" ? "Book Now " : "Pay Now"}
                companyVariables={companyVariables}
                job={props.job}
                lineItems={lineItems}
                refresh={async (): Promise<void> => {
                    await props.reloadJob()
                    return await getTransactions()
                }}
            />}

        </Box>
    );
}

export default React.memo(PaymentsTab)
